import React, { useState } from "react";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";

export default function FileUpload({ onUploaded, testId = "file-upload", label = "Upload photo", isPublic = false }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      fd.append("is_public", isPublic ? "true" : "false");
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded?.(data);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <label
      className="inline-flex items-center gap-2 cursor-pointer btn-outline-sage text-sm"
      data-testid={testId}
    >
      {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
      {uploading ? "Uploading..." : label}
      <input type="file" className="hidden" accept="image/*,.pdf" onChange={handleFile} disabled={uploading} />
    </label>
  );
}
